import { useSearchParams } from 'react-router-dom';
import { AvailabilityUserStatus } from '../../../availabilityUser/types';
import useAvailabilityUserService from '../../../availabilityUser/useAvailabilityUserService';
import { isEmployeeId } from 'framework/utils';

export const RECIPIENT_URL_PARAM = 'recipient';
export const MESSAGE_URL_PARAM = 'message';

const findRecipientByName = (items: AvailabilityUserStatus[], query: string) => {
  const normalizedQuery = query.trim().toLowerCase();

  return items.find(item => item.employeeName.trim().toLowerCase() === normalizedQuery) || items[0] || null;
};

const useTaskStatusPingInitialData = () => {
  const [searchParams] = useSearchParams();
  const { getAvailabilityUserById, searchAvailabilityUsers } = useAvailabilityUserService();

  const getDefaultRecipient = async () => {
    const normalizedEmployee = searchParams.get(RECIPIENT_URL_PARAM)?.trim();

    if (!normalizedEmployee) {
      return null;
    }

    if (isEmployeeId(normalizedEmployee)) {
      return await getAvailabilityUserById(normalizedEmployee);
    }

    const response = await searchAvailabilityUsers(normalizedEmployee);
    return findRecipientByName(response.result || [], normalizedEmployee);
  };

  const getInitialData = async () => ({
    message: searchParams.get(MESSAGE_URL_PARAM) || '',
    recipient: await getDefaultRecipient(),
    source: 'davinci',
  });

  return {
    getInitialData,
  };
};

export default useTaskStatusPingInitialData;
